export default "__VITE_ASSET__CIAj1ze1__"